export default {
  "404": () => import("/src/layouts/404.vue").then(m => m.default || m),
  account: () => import("/src/layouts/account.vue").then(m => m.default || m),
  blank: () => import("/src/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/src/layouts/default.vue").then(m => m.default || m),
  error: () => import("/src/layouts/error.vue").then(m => m.default || m),
  home: () => import("/src/layouts/home.vue").then(m => m.default || m),
  single: () => import("/src/layouts/single.vue").then(m => m.default || m)
}